<p>polygon-factory rendered {{polygonCount}} polygons</p>
